import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

interface AddButtonProps {
  onClick: () => void;
  label: string;
  disabled?: boolean;
  startIcon?: React.ReactNode;
}

const AddButton: React.FC<AddButtonProps> = ({ onClick, label, disabled = false, startIcon = <AddIcon /> }) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={startIcon}
      onClick={onClick}
      disabled={disabled}
      sx={{
        whiteSpace: "nowrap",
        bgcolor: "#2e7d32",
        "&:hover": {
          bgcolor: "#1b5e20",
        },
      }}
    >
      {label}
    </Button>
  );
};

export default AddButton;
